var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatternLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12.3264,
    width: 7.53269,
    height: 7.53269,
    rx: 1,
    transform: "rotate(-45 0 12.3264)",
    fill: "#A1DFFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 3.97926,
    width: 5.62752,
    height: 5.62752,
    rx: 1,
    transform: "rotate(-45 12 3.97926)",
    fill: "#A1DFFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 23.1736,
    width: 10.145,
    height: 10.145,
    rx: 1,
    transform: "rotate(-45 9 23.1736)",
    fill: "#A1DFFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatternLeft);
export default __webpack_public_path__ + "static/media/pattern-left.d1eb50b5551c541cf7130753c141a71d.svg";
export { ForwardRef as ReactComponent };